import React, { useMemo } from "react";
import { connect } from "react-redux";

import { useWatch } from "antd/es/form/Form";

import DealStageType from "@mapmycustomers/shared/enum/DealStageType";
import { FormItem, LargeTextField } from "@mapmycustomers/ui";

import { ConditionalFormFieldRenderProps } from "@app/component/ConditionalFormField";
import { getFunnelStages } from "@app/store/deal";
import { RootState } from "@app/store/rootReducer";

interface DealLossCommentFieldProps extends ConditionalFormFieldRenderProps {}

const DealLossCommentField = ({
  disabled,
  funnelStages,
  label,
  required,
  variant,
}: DealLossCommentFieldProps & ReturnType<typeof mapStateToProps>) => {
  const funnelId = useWatch("funnelId");
  const stageId = useWatch("stageId");
  const isLostStage = useMemo(
    () => funnelStages[funnelId]?.find(({ id }) => id === stageId)?.type === DealStageType.LOST,
    [funnelStages, funnelId, stageId]
  );

  // hide this field for non-lost stages, but only if we're not using a variant (i.e. for parent layout)
  const hideForNonLostStages = !variant;
  // if we hide field for non-lost stages and this is a non-lost stage, return null
  if (hideForNonLostStages && !isLostStage) {
    return null;
  }

  return (
    <FormItem
      label={label}
      name="dealLossComment"
      required={required}
      rules={[{ required }]}
      showLabel={false}
    >
      <LargeTextField disabled={disabled} label={label} required={required} />
    </FormItem>
  );
};

const mapStateToProps = (state: RootState) => ({
  funnelStages: getFunnelStages(state),
});

export default connect(mapStateToProps)(DealLossCommentField);
